import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/cuidado")({
  head: () => labHead(
    "/lab/cuidado",
    "Mapa do cuidado",
    "Mapa do cuidado: ajuda, cooperação e esperança conectadas por lugar, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: CareLab,
});

function CareLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/?obra=cuidado" title={{ pt: "Mapa do cuidado", en: "Map of care", es: "Mapa del cuidado" }} />;
}